export default __webpack_public_path__ + "static/media/signup.ac8b12cd.jpg";